import React, { useEffect, useCallback } from 'react';
import { PropTypes as PT } from 'prop-types';
import { loadUrl, getLoginDomain, getOrigin } from 'utils/UrlUtil';
import { withRouter, Redirect } from 'react-router-dom';
import { nucleusConstants } from '@lifesize/nucleus';
import LoadingComp from 'components/LoadingAnimation/LoadingAnimation';
import { logger } from 'utils/logger';
import lsConfig from 'utils/global-config';
import _isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';

export const Auth = (props) => {
  const { isLoggedIn, ipAddressOverride, registeredLogin } = props;

  const handleError = useCallback(
    (error) => {
      const fatalJwtError = !get(error, 'willRetry') && get(error, 'reason') === nucleusConstants.WAMP_JWT_ERROR_REASON;
      if (props.authFailure || fatalJwtError) {
        // authentication failed, let's redirect to the login domain
        lsConfig.skipOnBeforeUnload();
        loadUrl(getLoginDomain(props.endRoute ? `${getOrigin()}${props.endRoute}` : null, props.loginLanguage));
      }
    },
    [props.authFailure, props.endRoute, props.loginLanguage]
  );

  const handleLogin = useCallback(() => {
    registeredLogin().catch((error) => {
      handleError(error);
    });
  }, [handleError, registeredLogin]);

  useEffect(() => {
    if (ipAddressOverride) {
      logger.info(`IP override detected. Node locked to ${props.ipAddressOverride}`);
    }

    if (props.shouldLogin) {
      handleLogin();
    }
    /*
      This function should get called once when component mounts initially.
      If dependency is declared it will cause infinite loop which will break desktop and webclient.
      We have made an exception to use it with empty array for this hook.
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      if (_isUndefined(window.Notification)) {
        logger.info('This browser does not support desktop notification');
      } else if (window.Notification.permission !== 'granted') {
        window.Notification.requestPermission();
      }
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <Redirect push to={props.endRoute} />;
  }

  if (props.reload) {
    return null;
  }

  return <LoadingComp />;
};

Auth.propTypes = {
  authFailure: PT.bool,
  endRoute: PT.string,
  ipAddressOverride: PT.string,
  isLoggedIn: PT.bool,
  loginLanguage: PT.string,
  registeredLogin: PT.func.isRequired,
  reload: PT.bool,
  shouldLogin: PT.bool
};

export default withRouter(Auth);
